import React from 'react'
import { BGWrapper, FakeBGImg, Content } from './BGImage.styles'

export const BGImage = ({ image, title, className, children }) => {
    return (
        <BGWrapper>
            <Content className={className}>{children}</Content>
            <FakeBGImg loading="eager" placeholder="none" image={image} title={title} />
        </BGWrapper>
    )
}

export default BGImage
